// extracted by mini-css-extract-plugin
export default {"input":"InputWhite_input__ly6mc","textarea":"InputWhite_textarea__+oJof"};